import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RoomsOverlayService } from './rooms-overlay.service'
import { RoomsOverlayComponent } from './rooms-overlay.component'
import { ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { MatInputModule } from '@angular/material/input'
import { Tv3PlatformModule } from '@tokeet/tv3-platform'
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatSortModule } from '@angular/material/sort'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { RoomsLibraryModule } from '../../store/rooms/rooms.module'
import { RoomFormComponent } from './room-form/room-form.component'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    Tv3PlatformModule,
    MatTableModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatSortModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    RoomsLibraryModule,
  ],
  declarations: [RoomsOverlayComponent, RoomFormComponent],
  providers: [RoomsOverlayService],
  exports: [RoomsOverlayComponent, RoomFormComponent],
})
export class RentalRoomsModule {}
